export default __webpack_public_path__ + "static/media/chocodoDark.27cf03ad.png";